import type { UseCase } from '@contexts/shared/application';
import { numberValueObject, uuidValueObject } from '@contexts/shared/domain';
import type { UpdateLastAlertsCheckInput, User, UserRepository } from '@contexts/users/domain';

export type UpdateLastAlertsCheckUseCase = UseCase<UpdateLastAlertsCheckInput, User>;

export function updateLastAlertsCheckBuilder(
	userRepository: UserRepository
): UpdateLastAlertsCheckUseCase {
	return async function updateLastAlertsCheck(input: UpdateLastAlertsCheckInput): Promise<User> {
		const id = uuidValueObject().validate('id', input.id);
		const lastAlertsCheck = numberValueObject().validate(
			'lastAlertsCheck',
			input.lastAlertsCheck
		);

		return userRepository.updateLastAlertsCheck({ id, lastAlertsCheck });
	};
}
